import React, { Component } from 'react';
import './App.css';
import Engine from './Components/Engine';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">The game of Life</h1>
        </header>
        <Engine/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js